import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, Button, Modal } from 'reactstrap';
import { AlertTriangle, CheckCircle, ChevronLeft } from 'react-feather';
import { Row, Col, } from 'reactstrap';
import Presenter from './Presenter';
import ModalPopup from './ModalPopup';
import IconPlus from "../assets/images/icon-plus.png";

/**
 * Renders the PageTitle
 */
interface rootProps{
    title:string,
    breadCrumbItems:any,
    goBack?:any,
    rightComponent?:any,
    subComponent?:any,
    type?:string,
    data?:any,
    user?:any
}
const PageTitle = (props:rootProps) => {
    const {data, type, user} = props;
    const title = props.title || "";
    const items = props.breadCrumbItems || "";
    const goBack = props.goBack;

    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState();

    const handleActionModal = (item: any) => {
        setAction(item);
        setIsOpen(true);
    };

    return (
        <>
            <>
                <Row className="page-title">
                    <Col md={type == 'presenter' ? 10 : 12}>
                        {/* <Breadcrumb className="float-right mt-1 font-size-14 d-none d-sm-block">
                            <BreadcrumbItem>
                                <Link to="/">Trang chủ</Link>
                            </BreadcrumbItem>
                            {items.map((item:any, index:number) => {
                                return item.active ? (
                                    <BreadcrumbItem active key={index}>
                                        {item.label}
                                    </BreadcrumbItem>
                                ) : (
                                        <BreadcrumbItem key={index}>
                                            <Link to={item.path}>{item.label}</Link>
                                        </BreadcrumbItem>
                                    );
                            })}
                        </Breadcrumb> */}
                        <div style={{float: 'left', display: 'flex', flexDirection: 'column'}}>
                            {goBack &&
                                typeof goBack === "string"?
                                <Link to={goBack}><ChevronLeft style={{marginRight:10,cursor: 'pointer'}}/></Link>: goBack&&
                                <span onClick={goBack}><ChevronLeft style={{marginRight:10,cursor: 'pointer'}}/></span>
                            }
                            <h4 className="mb-0 mt-0">{title}</h4>
                            {props?.subComponent && props.subComponent}
                        </div>
                        {props?.rightComponent && props.rightComponent}
                    </Col>
                    {
                        (type == 'presenter' && data?.id) && (
                            <Col md={2}>
                                <div className="text-right">
                                    <Button color="success" className="ml-2" onClick={() => handleActionModal({data: data})}>
                                    <img
                                        className="mr-1"
                                        style={{ border: "none" }}
                                        src={IconPlus}
                                        width={20}
                                        height={20}
                                        alt=""
                                    />
                                        Giới thiệu dịch vụ
                                    </Button>
                                </div>
                            </Col>
                        )
                    }
                </Row>
                <ModalPopup
                    isOpen={modalIsOpen}
                    onRequestClose={() => setIsOpen(false)}
                >
                    <RenderActionModal 
                        closeModal={() => setIsOpen(false)}
                        action={action}
                        data={data}
                        user={user}
                    />
                </ModalPopup>
            </>
            

            {/* <div className="alert alert-warning-opacity alert-dismissible fade show" role="alert">
                <AlertTriangle className="icon-warning mr-3"/> 
                <span>Hồ sơ của bạn sẽ được phê duyệt trong vòng 1-2 ngày. Bạn vẫn có thể cập nhật hồ sơ trước khi được phê duyệt. </span>
            </div>
            <div className="alert alert-success-opacity alert-dismissible fade show" role="alert">
                <CheckCircle className="icon-success mr-3"/> 
                <span>Những thông tin đã lưu sẽ không được chỉnh sửa. Nếu muốn chỉnh sửa, vui lòng trao đổi qua hotline 1800 1126</span>
            </div>
            <div className="alert alert-danger-opacity alert-dismissible fade show" role="alert">
                <AlertTriangle className="icon-danger mr-3"/> 
                <span>Những thông tin đã lưu sẽ không được chỉnh sửa. Nếu muốn chỉnh sửa, vui lòng trao đổi qua hotline 1800 1126</span>
            </div> */}
        </>
    )
}

const RenderActionModal = (props: any) => {
    const {closeModal, data, user} = props;
    return (
        <Presenter closeModal={closeModal} data={data} user_operation={user}/>
    )
}

export default PageTitle;